
<div class="rate-plan-summary">
  @if (ratePlan && ratePlan.RatePlanCalculations) {
    <div class="open-booking-summary__rate-plan">
      <div class="open-booking-summary__section-title">
        {{'rates' | translate}}
      </div>
      @for (slot of ratePlan.SlotList; track slot; let index = $index) {
        <mat-accordion>
          <mat-expansion-panel [expanded]="index == 0"
            class="open-booking-summary__summary-accordian--panel open-booking-summary__summary-accordian--rate-plan">
            <mat-expansion-panel-header>
              <mat-panel-title class="open-booking-summary__section-title--accordian">
                @if (isSessionClass) {
                  <span>
                    {{slot.TimeRange.Start | date:'dd MMMM, hh:mm a' }} - {{slot.TimeRange.End | date:'hh:mm
                    a'}}
                  </span>
                }
                @if (!isSessionClass) {
                  <span>
                    {{slot.TimeRange.Start | localizeDate: 'DD MMMM' }} - {{slot.TimeRange.End | localizeDate: 'DD MMMM'}}
                  </span>
                }
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (slot.RatePlanVariants.TotalBaseRate) {
              <div class="open-booking-summary__rate-row">
                <div class="open-booking-summary__rate-label">
                  <span class="open-booking-summary__rate-label--main">{{'TotalBaseRate' | translate}}</span>
                </div>
                <div class="open-booking-summary__rate">{{OperationCurrency}} {{slot.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter}}</div>
              </div>
            }
            @if (slot.RatePlanVariants.LocationVariant) {
              <div class="open-booking-summary__rate-row">
                <div class="open-booking-summary__rate-label">
                  <span class="open-booking-summary__rate-label">{{'LocationVariant' | translate}} <span
                    class="sub-text">({{'forTotalOf' | translate}}
                    {{activityService.SessionBookingObj?.BookingSize}}
                  )</span>
                </span>
              </div>
              <div class="open-booking-summary__rate">{{OperationCurrency}}
              {{slot.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
            </div>
          }
          @if (slot.RatePlanVariants.InstructorVariant) {
            <div class="open-booking-summary__rate-row">
              <div class="open-booking-summary__rate-label">
                <span class="open-booking-summary__rate-label">{{'InstructorVariant' | translate}}<span
                  class="sub-text">({{'forTotalOf' | translate}}
                  {{activityService.SessionBookingObj?.BookingSize}}
                )</span></span>
              </div>
              <div class="open-booking-summary__rate">{{OperationCurrency}}
              {{slot.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
            </div>
          }
          @if (slot.bookingTypeVariants && slot.bookingTypeVariants.length) {
            <div class="open-booking-summary__rate-row">
              <div class="open-booking-summary__rate-label">
                <span class="open-booking-summary__rate-label sub-label">{{'bookingType' | translate}} </span>
              </div>
            </div>
          }
          @for (variant of slot.bookingTypeVariants; track variant) {
            <div class="open-booking-summary__rate-row">
              @if (variant.Variant) {
                <div class="open-booking-summary__rate-label">
                  <span class="open-booking-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                  <span class="open-booking-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                </div>
              }
              <div class="open-booking-summary__rate">{{OperationCurrency}} {{variant.Variant | currencyDecimalFormatter}}</div>
            </div>
          }
          @if (slot.coverTypeVariants && slot.coverTypeVariants.length) {
            <div class="open-booking-summary__rate-row">
              <div class="open-booking-summary__rate-label">
                <span class="open-booking-summary__rate-label sub-label">{{'coverType' | translate}} </span>
              </div>
            </div>
          }
          @for (variant of slot.coverTypeVariants; track variant) {
            <div class="open-booking-summary__rate-row">
              @if (variant.Variant) {
                <div class="open-booking-summary__rate-label">
                  <span class="open-booking-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                  <span class="open-booking-summary__rate-label--sub">{{variant.covers}}</span>
                </div>
              }
              <div class="open-booking-summary__rate">{{OperationCurrency}} {{variant.Variant | currencyDecimalFormatter}}</div>
            </div>
          }
          @if (slot.MemberShipVariant) {
            <div class="open-booking-summary__rate-row">
              <div class="open-booking-summary__rate-label">
                <span class="open-booking-summary__rate-label--main">{{'MemberShipVariant' | translate}}</span>
              </div>
              <div class="open-booking-summary__rate">{{OperationCurrency}} {{slot.MemberShipVariant | currencyDecimalFormatter}}
              </div>
            </div>
          }
          <div class="open-booking-summary__rate-row">
            <div class="open-booking-summary__rate-label">
              <span class="open-booking-summary__rate-label--main">{{'TotalSessionCharge' | translate}}</span>
            </div>
            <div class="open-booking-summary__rate">{{OperationCurrency}} {{slot.TotalAmount | currencyDecimalFormatter}}</div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    }
    <div class="open-booking-summary__rate-row open-booking-summary__total">
      <div class="open-booking-summary__rate-label">
        <span class="open-booking-summary__rate-label">{{'total' | translate}}</span>
      </div>
      <div class="open-booking-summary__rate">{{OperationCurrency}} {{(ratePlan.TotalRatePlan || 0) | currencyDecimalFormatter }}
      </div>
    </div>
  </div>
}
</div>